export enum InitActionType {
  ZAINICJALIZUJ_TOKEN = '[Init] Zainicjalizuj token',
  POBIERZ_DANE_ZGLOSZENIA_SUCCESS = '[Init] Pobrano dane zgloszenia',
  POBIERZ_PARAMETRY_WYCENY_SZKODY = '[Init] pobierz parametry wyceny szkody oraz parametr minimalnego roszczenia',
  POBIERZ_TOGGLES = '[Init] pobierz parametry toggli',
  ZALADUJ_STORE_Z_SESSION_STORAGE = '[Init] Zaladuj store z session storage',
  ROZPOCZNIJ_SAMOOBSLUGE = '[Init] Rozpocznij samoobsluge',
}
